import { http, createConfig } from 'wagmi'
import { blast } from 'wagmi/chains'

export const config = createConfig({
  chains: [blast],
  transports: {
    [blast.id]: http(),
  },
})
